import {getProp, CanBeSignal} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store, ComputedSignal, Signal} from '@gongxigames/framework/core/fragments/store/Store';
import type {SpinBtnMode, SpinBtnCurrentAction} from './SpinBtn';

export function computedBtnType(mode: CanBeSignal<SpinBtnMode>, btnAction: CanBeSignal<SpinBtnCurrentAction>): ComputedSignal<string> {
    return Store.computed(() => {
        const currentMode = getProp(mode);
        const currentBtnAction = getProp(btnAction);

        let btnType = currentBtnAction === 'stop' ? 'stop' : 'spin';

        if (currentMode === 'autoplay') {
            btnType = 'autospin';
        }

        if (currentMode === 'free_spins') {
            btnType = 'free_spins';
        }

        if (currentMode === 'hold_for_turbo_active') {
            btnType = 'turbospin';
        }

        return btnType;
    });
}

export function computedIcon(focused: CanBeSignal<boolean>, disabled: CanBeSignal<boolean>, btnType: Signal<string>): ComputedSignal<string> {
    return Store.computed(() => {
        const focusedState = getProp(focused);
        const disabledState = getProp(disabled);

        let btnState = focusedState ? 'focused' : 'normal';

        if (disabledState) {
            btnState = 'disabled';
        }

        return `${btnState}_${btnType.value}`;
    });
}

